/**
 * Retorna uma string formatada para a data fornecida.
 * Se a data for ontem, hoje ou amanhã, retorna "Ontem", "Hoje" ou "Amanhã".
 * Caso contrário, retorna no formato "Quarta-feira, 4 de Jun. 2025".
 * @param {Date} date - Data a ser formatada
 * @param {Date} [now=new Date()] - Data de referência (opcional, padrão: hoje)
 * @param {boolean} [includeYear=true] - Incluir o ano na string formatada
 * @returns {string}
 */
export function formatDate(
  date: Date,
  now: Date = new Date(),
  simple = false
): string {
  const diasSemana = ['Dom.', 'Seg.', 'Ter.', 'Qua.', 'Qui.', 'Sex.', 'Sáb.']
  const meses = [
    'Jan.',
    'Fev.',
    'Mar.',
    'Abr.',
    'Mai.',
    'Jun.',
    'Jul.',
    'Ago.',
    'Set.',
    'Out.',
    'Nov.',
    'Dez.',
  ]

  // Zera horas para comparar apenas datas
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const n = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  const diff = (d.getTime() - n.getTime()) / (1000 * 60 * 60 * 24)

  const diaSemana = diasSemana[d.getDay()]
  const dia = d.getDate()
  const mes = meses[d.getMonth()]
  // const ano = d.getFullYear()
  const dayAndMonth = simple ? '' : `, ${`${dia} de ${mes}`}`
  if (diff === -1) return `Ontem${dayAndMonth}`
  if (diff === 0) return `Hoje${dayAndMonth}`
  if (diff === 1) return `Amanhã${dayAndMonth}`
  return `${simple ? '' : diaSemana + ', '} ${`${dia} de ${mes}`}`
}
